var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnParameters = function SvgIcnParameters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.192 6.814a2.568 2.568 0 0 1-4.73 0H3.086a1 1 0 0 1 0-2h1.374a2.568 2.568 0 0 1 4.73 0h11.721a1 1 0 0 1 0 2H9.192Zm-2.366.067a1.067 1.067 0 1 0 0-2.134 1.067 1.067 0 0 0 0 2.134ZM3.087 13h11.721a2.568 2.568 0 0 0 4.73 0h1.374a1 1 0 1 0 0-2h-1.374a2.568 2.568 0 0 0-4.73 0H3.088a1 1 0 1 0 0 2Zm14.086-2.067a1.067 1.067 0 1 0 0 2.134 1.067 1.067 0 0 0 0-2.134ZM6.808 19.186h-3.72a1 1 0 1 1 0-2h3.72a2.568 2.568 0 0 1 4.738.019 1.01 1.01 0 0 1 .194-.019h9.172a1 1 0 1 1 0 2H11.74c-.066 0-.131-.006-.194-.019a2.568 2.568 0 0 1-4.738.019Zm1.298-1a1.067 1.067 0 1 1 2.134 0 1.067 1.067 0 0 1-2.134 0Z",
    fill: "#292525"
  })));
};
export default SvgIcnParameters;